import React, { useEffect } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { commonServices } from "../../../../api/services/commonServices";
import moment from "moment";
import {
  setCalendarData,
  setDashboardCalendarLoader,
} from "../../../../infra/aggregates/dashboardCalendarSlice";

const DTODashboardCalendarData = (prop) => {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  const getDashboardCalendarDataCall = () => {
    dispatch(setDashboardCalendarLoader(true));

    const getCurrentMonth = moment().get("month");
    const getCurrentYear = moment().get("year");
    const _currentMonth = getCurrentMonth + 1;
    commonServices
      .getCalendarData(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        _currentMonth,
        getCurrentYear
      )
      .then((response) => {
        if (response?.data?.leaves) {
          dispatch(setCalendarData(response?.data));
          prop.setAllDashboardCalendarData(response?.data);
          dispatch(setDashboardCalendarLoader(false));
        }
      })
      .catch((err) => {
        dispatch(setDashboardCalendarLoader(false));
        console.log(err);
      });
  };
  useEffect(() => {
    getDashboardCalendarDataCall();
  }, []);

  return <></>;
};

export default DTODashboardCalendarData;
